import { Injectable } from '@angular/core'

@Injectable()
export class AppConfigService {
    private responseConfig: any
    commonSetting: any
    behaviorSetting: any
    mailSetting: any
    staffs: string[]
    doctors: string[]
    timelineForms: string[]

    timelineTags: string[]
    chatTags: string[]
    messageTags: string[]
    alignerTags: string[]


    constructor() {
    }

    initConfig(responseConfig, staffs = []) {
        this.responseConfig = responseConfig
        this.commonSetting = responseConfig['map']['common']
        this.behaviorSetting = this.findBehaviorConfig(responseConfig['paths']['{}'])

        this.alignerTags = this.behaviorSetting ? this.behaviorSetting.alignerStatus : []
        this.chatTags = this.behaviorSetting ? this.behaviorSetting.chatTag : []
        this.timelineTags = this.behaviorSetting ? this.behaviorSetting.noteTag : []
        this.messageTags = this.behaviorSetting ? this.behaviorSetting.roomMessageTag : []

        this.convertTagsObject(this.behaviorSetting ? this.behaviorSetting.timelineForms : [])
        this.staffs = staffs
    }

    findBehaviorConfig(configPaths: any[]) {
        const optionIndex = configPaths.findIndex(i => i._id === 'option')
        return configPaths[optionIndex]
    }

    convertTagsObject(timelineForms) {
        this.timelineForms = timelineForms ? timelineForms.reduce(function(acc, cur, i) {
            acc[cur._id] = cur.title
            return acc
        }, {}) : []
    }
}



// WEBPACK FOOTER //
// ./src/app/services/app-config.service.ts